// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6f88eac8","147":"48198676","265":"846fea62","295":"db170bc8","574":"6c85020d","807":"efa01a30","818":"aff1d04c","899":"2a5ca915","900":"815301c4","996":"6311b09d"}[chunkId] + ".chunk.js";
};